import line from './line.vue'
line.install = function (Vue) {
  Vue.component(line.name, line);
};
export default line



// WEBPACK FOOTER //
// ./src/ni-ui/line/index.js